(function () {
  angular.module("akitabox.core.root", ["ui.router", "akitabox.core.router"]);
})();
